import { MedicareAgent } from '@/consent/medicare/domain/MedicareAgent';
import { CONTACT_PREFERENCE_TYPES } from '@hfc/common/src/types/ContactPreferenceTypes';

export class MedicareAgentCollection {

  private agents: Array<MedicareAgent>;

  public constructor (agents: Array<MedicareAgent>) {
    this.agents = agents;
  }

  public getAgent (name: string):MedicareAgent {
    const agent = this.agents.find(agent => agent.key === name);
    if (!agent) {
      return this.getDefaultAgent();
    }

    return agent;
  }

  public getAgentsNames ():Array<string> {
    return this.agents.map(agent => agent.key);
  }

  public isAgentEnabled (name: string):boolean {
    return this.agents.find(agent => agent.key === name) !== undefined;
  }

  public getDefaultAgent (): MedicareAgent {
    return this.agents.length ? this.agents[0] : {} as MedicareAgent;
  }

  public getRoundRobinLink (contactMethod?: CONTACT_PREFERENCE_TYPES): string {
    return contactMethod === CONTACT_PREFERENCE_TYPES.TEXT
      ? 'https://calendly.com/medicare-agents/schedule-your-medicare-consultation-clone'
      : 'https://calendly.com/medicare-agents/schedule-your-medicare-consultation';
  }

}
